// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__29nld","selects":"Documents_selects__5quqF"};